<template>
    <div class="flex">
        <button class="layout-topbar-button" aria-haspopup="true" aria-controls="i18n_menu" @click="showLanguages">
            <img v-if="currentLanguage" class="w-[20px]" :src="currentLanguage.imgSrc" :alt="currentLanguage.name">
            <span v-if="currentLanguage" class="ml-1">{{ currentLanguage.name }}</span>
        </button>
        <Menu ref="menu" :model="languages" :popup="true">
            <template #item="{ item, props }">
                <a v-bind="props.action" @click="changeLocale($event, item.locale)">
                    <img class="w-[15px]" :src="item.imgSrc" :alt="item.name">
                    <span class="ml-2" data-pc-section="label">{{ item.name }}</span>
                </a>
            </template>
        </Menu>
    </div>
</template>

<script lang="ts" setup>
    import { setLocale } from '@vee-validate/i18n'
    import { usePrimeVue } from 'primevue/config'
    import Menu from 'primevue/menu'
    import { computed, useTemplateRef } from 'vue'
    import { useI18n } from 'vue-i18n'

    import enImage from '@/assets/images/country-flags/en.png'
    import slImage from '@/assets/images/country-flags/sl.png'
    import dayjs from '@/libs/dayjs.ts'
    import { changePrimevueLanguage } from '@/libs/primevue.ts'

    interface Language {
        locale: string
        imgSrc: string
        name: string
    }

    // data
    const primevue = usePrimeVue()
    const i18n = useI18n()
    const menu = useTemplateRef<InstanceType<typeof Menu>>('menu')
    const languages: Language[] = [
        {
            locale: 'sl',
            imgSrc: slImage,
            name: 'Slovenščina'
        },
        {
            locale: 'en',
            imgSrc: enImage,
            name: 'English'
        }
    ]

    // methods
    const showLanguages = (event: Event) => {
        if (menu.value) menu.value.toggle(event)
    }

    const changeLocale = (event: Event, newLocale: string) => {
        i18n.locale.value = newLocale
        dayjs.locale(newLocale)
        setLocale(newLocale)
        changePrimevueLanguage(primevue, newLocale)
        localStorage.setItem('locale', newLocale)

        if (menu.value) menu.value.toggle(event)
    }

    // computed
    const currentLanguage = computed((): Language | null => {
        const index = languages.findIndex(x => x.locale === i18n.locale.value)
        return index > -1 && languages[index] ? languages[index] : null
    })
</script>
